module.exports = __webpack_public_path__ + "img/1-affiliate.1b6cd726.png";